<template>
  <div class="index-block-title">
    <div class="title">{{ title }}</div>

    <div class="en">{{ en }}</div>

    <div class="block"></div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    en: {
      type: String,
      default: ''
    },
  },

  data() {
    return {
    }
  }
}
</script>

<style lang="scss">
.index-block-title {
  text-align: center;
  margin-bottom: 30px;

  .title {
    font-size: 36px;

    font-weight: normal;
    color: #0A1121;
    margin-bottom: 12px;
  }

  .en {
    font-size: 16px;
    // font-family: Helvetica;
    font-weight: 300;
    color: #878A95;
  }

  .block {
    width: 40px;
    height: 3px;
    background: #1296DB;
    display: inline-block;
  }
  
}
</style>
